export default __webpack_public_path__ + "static/cmc_logo-0518fe9bd09b4d6bb0d3e0d519c02081.svg";